import { Calendar, momentLocalizer } from 'react-big-calendar';
import { parseISO } from 'date-fns';

import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment); // or use date-fns

const ResultViewAsCalendar = ({ workoutProgram }) => {
  const events = workoutProgram.flatMap((day, dayIndex) =>
    day.exercises.map((exercise, exerciseIndex) => {
      const baseDate = new Date(); // Or align this with a start date the user picks
      const workoutDate = new Date(baseDate);
      workoutDate.setDate(baseDate.getDate() + dayIndex); // Day 1 = today, Day 2 = tomorrow, etc.

      return {
        title: `${exercise.sets}x${exercise.reps} ${exercise.name} @ ${exercise.weight.value}${exercise.weight.unit}`,
        start: new Date(workoutDate.setHours(18)), // 6PM
        end: new Date(workoutDate.setHours(19)),   // 7PM
        allDay: false,
      };
    })
  );

  return (
    <div className="calendar-container fogged-card">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600 }}
      />
    </div>
  );
};

export default ResultViewAsCalendar;